import { Breadcrumb, Button, Col, Divider, Drawer, Dropdown, Empty, Flex, Form, Input, Layout, Popconfirm, Radio, Row, Select, Table, Tag, theme, Typography, message, notification, Tooltip, Pagination } from 'antd';
import { CopyOutlined, HomeOutlined, DeleteOutlined, MoreOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import Templates from '../../../helperComponents/Templates';
import RequestApproval from '../../../restAPI/RequestApproval';
import dayjs from 'dayjs';
import CommonSkeletonLoader from '../../../helperComponents/CommonSkeleton';


const { Header, Footer, Sider, Content } = Layout;
const { Search, TextArea } = Input;
const { Option } = Select;
const { Text } = Typography;

export default function TemplateManager({ props }) {

    const [filterValues, setFilterValues] = useState({});
    const [open2, setOpen2] = useState(false);
    const [openNewDrawer, setOpenNewDrawer] = useState(false);
    const [forceRender, setForceRender] = useState(0);
    const [openMakeCopyDrawer, setOpenMakeCopyDrawer] = useState(false);
    const [openEditDrawer, setOpenEditDrawer] = useState(false);
    const createTemplateRef = useRef(null);
    const makecopyTemplateRef = useRef(null);
    const editTemplateRef = useRef(null);
    const [selectedMakeCopyTemplate, setSelectedMakeCopyTemplate] = useState(null);
    const [selectedEditTemplate, setSelectedEditTemplate] = useState(null);
    const [isTemplateListLoading, setIsTemplateListLoading] = useState(false);

    const [paginatedItems, setPaginatedItems] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);

    const [myTemplates, setMyTemplstes] = useState([]);
    const [myTemplatesV2, setMyTemplstesv2] = useState([]);
    const [searchTemplateValue, setSearchTemplateValue] = useState("");
    // const editTemplateRef = useRef(null);

    const pageSize = 10; // Number of items per page

    const { companyId, token, userCompany } = useSelector(state => state.auth);
    RequestApproval.testWithJWTandCID(companyId, token);

    const getMyTemplates = () => {
        console.log("Tem");
        const data = RequestApproval.getTemplates().then((data) => {
            const paginadItems = data.data.slice(0, 0 + pageSize);
            setPaginatedItems(paginadItems)
            setMyTemplstes(data.data);
            setMyTemplstesv2(data.data);
            console.log(data, "Tem");
            setIsTemplateListLoading(false);
        }).catch((error) => {
            setIsTemplateListLoading(false);
        });

    }

    useEffect(() => {
        setIsTemplateListLoading(true);
        getMyTemplates();
    }, [companyId])

    useEffect(() => {
        setIsTemplateListLoading(true);
        // console.log(savedData,"data that coming into template view from index")
        getMyTemplates();
        // setSelectedTemplate(savedData);
        // if(savedData !== null ){

        //     }
        // }

    }, [forceRender]);
    useEffect(() => {

        // console.log(savedData,"data that coming into template view from index")
        console.log(selectedEditTemplate, "selected template")
        // setSelectedTemplate(savedData);
        // if(savedData !== null ){

        //     }
        // }

    }, [selectedEditTemplate]);

    useEffect(() => {

        // console.log(savedData,"data that coming into template view from index")
        console.log(selectedMakeCopyTemplate, "selected template")
        // setSelectedTemplate(savedData);
        // if(savedData !== null ){

        //     }
        // }

    }, [selectedMakeCopyTemplate]);
    // drawer handling for search filter
    const showDrawer2 = () => {
        setOpen2(true);
    };
    const onClose2 = () => {
        setOpen2(false);
    };

    const showNewDrawer = () => {
        setOpenNewDrawer(true);
    };
    const showMakecopyDrawer = () => {
        setOpenMakeCopyDrawer(true);
    };
    const showEditDrawer = () => {
        setOpenEditDrawer(true);
    };
    const closeNewDrawer = () => {
        setOpenNewDrawer(false);
        setOpenMakeCopyDrawer(false);
        setOpenEditDrawer(false);
        setSelectedEditTemplate(null)
        setSelectedEditTemplate(null)
        setForceRender(forceRender + 1)
    };
    const closeDrawer = () => {
        setOpenNewDrawer(false);
        setOpenMakeCopyDrawer(false);
        setOpenEditDrawer(false);
        setSelectedEditTemplate(null)
        setSelectedEditTemplate(null)
    };
    const saveTemplate = () => {
        const status = createTemplateRef.current.validateAndSaveTemplate();
        //setForceRender(forceRender+1)

    }
    const saveEditTemplate = () => {
        const status = editTemplateRef.current.validateAndSaveTemplate();

        //setForceRender(forceRender+1)
    }
    const saveMakecopyTemplate = () => {
        const status = makecopyTemplateRef.current.validateAndSaveTemplate();
        //setForceRender(forceRender+1)

    }


    const [api, contextHolder] = notification.useNotification();
    const openNotification = (type, message, description, placement) => {
        api[type]({
            message: message,
            description: description,
            placement
        });
    };

    const items = [
        {
            label: (
                <a href="" target="_blank" rel="">
                    Make A Copy
                </a>
            ),
            key: '0',
            icon: <CopyOutlined />,
        },
        {
            label: (
                <a href="" target="_blank" rel="">
                    Edit
                </a>
            ),
            key: '1',
            icon: <EditOutlined />,
        },
    ];
    const searchTemplate = (e) => {
        let searchvalue = e.target.value.replace(/^\s+/, "").toLowerCase();
        let regex = new RegExp(`${searchvalue}`);
        setSearchTemplateValue(searchvalue);
        const data = myTemplatesV2.filter(element => regex.test(element.name.toLowerCase()));
        setMyTemplstes(data);
        const startIndex = (currentPage - 1) * pageSize;
        const paginadItems = data.slice(startIndex, startIndex + pageSize);
        setPaginatedItems(paginadItems);
        // console.log(searchvalue,"searched value");
        // const data = 

    }

    const deleteTemplatebyId = async (item) => {
        setIsTemplateListLoading(true);
        console.log(item, "deleteign item")
        await RequestApproval.deletetemplateById(item._id)
            .then((response) => {
                // message.success('Remove Template Successfully!');
                openNotification('success', 'Success', `Remove Template Successfully!`, 'bottomLeft');

                getMyTemplates();
            })
            .catch((err) => {
                setIsTemplateListLoading(false);
                if (err.response) {
                    // message.error(`${err.response.data.message}`);
                    openNotification('error', 'Error', `${err.response.data.message}`, 'bottomLeft');
                } else {
                    // message.error('Remove Template Failed!');
                    openNotification('error', 'Error', `Remove Template Failed!`, 'bottomLeft');

                }
            });
    }
    // const setSelectedTemplatefunc=(item)=>{
    //     console.log(item,"selected item template")
    //     setSelectedTemplate(item);
    // }
    const pagination = (currentPage) => {
        const startIndex = (currentPage - 1) * pageSize;
        const paginadItems = myTemplates.slice(startIndex, startIndex + pageSize);
        setCurrentPage(currentPage);
        setPaginatedItems(paginadItems)
    }

    const { token: { colorBgContainer, borderRadiusLG, colorTextDescription }, } = theme.useToken();

    return (
        <>
            {contextHolder}
            <Flex gap={20} justify='space-between' align='center' style={{
                margin: '16px',
                padding: '16px 24px',
                // minHeight: 280,
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
            }}>
                <Breadcrumb
                    items={[
                        {
                            href: '',
                            title: <HomeOutlined />,
                        },
                        {
                            title: 'Template Manager',
                        },
                    ]}
                />
                <Flex justify='center' align='center' gap={16}>
                    <Search
                        placeholder="Search template"
                        onChange={searchTemplate}
                        value={searchTemplateValue}
                    // enterButton
                    />
                    {/* <Input onChange={searchTemplate} value={searchTemplateValue} placeholder="Search template" /> */}
                    <Button type="primary" icon={<PlusOutlined />} onClick={showNewDrawer} >Create New</Button>
                </Flex>

            </Flex>
            <div style={{
                margin: '16px',
                // padding: 24,
                minHeight: "78svh",

                borderRadius: borderRadiusLG,
            }}>

                <Form layout="vertical">
                    {/* <Form.Item>
                        <Input onChange={searchTemplate} value={searchTemplateValue} placeholder="Search template name here" />
                    </Form.Item> */}
                    {/* List items repeated 5 times */}
                    {isTemplateListLoading ? (<CommonSkeletonLoader />) : (<>
                        {myTemplates.length !== 0 ? (
                            <div key={forceRender}>
                                {
                                    paginatedItems.map((item, index) => (
                                        <Flex
                                            key={index}
                                            gap={16}
                                            align="center"
                                            justify="space-between"
                                            style={{
                                                padding: '16px 24px',
                                                cursor: 'pointer',
                                                marginBottom: '16px',
                                                background: colorBgContainer,
                                                borderRadius: borderRadiusLG,
                                                width: '100%'
                                            }}
                                        >
                                            <Flex gap={16} justify="flex-start">
                                                <Flex gap={4} vertical justify="flex-start">
                                                    <Text strong>{item.name}</Text>
                                                    <Text style={{ color: colorTextDescription }}>
                                                        {dayjs(item.created_at).format('MMMM D, YYYY')}
                                                    </Text>
                                                </Flex>
                                            </Flex>
                                            <Flex gap={16}>
                                                <Tooltip title="Make a Copy">
                                                    <Button
                                                        type='default'
                                                        icon={<CopyOutlined />}
                                                        onClick={() => {
                                                            showMakecopyDrawer();
                                                            setSelectedMakeCopyTemplate(item);
                                                        }}
                                                    />
                                                </Tooltip>
                                                <Tooltip title="Edit">
                                                    <Button
                                                        type='primary'
                                                        icon={<EditOutlined />}
                                                        onClick={() => {
                                                            showEditDrawer();
                                                            setSelectedEditTemplate(item);
                                                        }}
                                                    />
                                                </Tooltip>
                                                <Tooltip title="Remove">
                                                    <Button
                                                        type='primary'
                                                        danger
                                                        icon={<DeleteOutlined />}
                                                        onClick={() => {
                                                            deleteTemplatebyId(item);
                                                        }}
                                                    />
                                                </Tooltip>
                                            </Flex>
                                            {/* <Dropdown
                                            menu={{
                                                items: [
                                                    {
                                                        label: ' Make A Copy',
                                                        key: '0',
                                                        icon: <CopyOutlined />,
                                                        onClick: () => {
                                                            showMakecopyDrawer();
                                                            setSelectedMakeCopyTemplate(item)
                                                        },
                                                    },
                                                    {
                                                        label: 'Edit',
                                                        key: '1',
                                                        icon: <EditOutlined />,
                                                        onClick: () => {
                                                            showEditDrawer();
                                                            setSelectedEditTemplate(item);

                                                        },
                                                    },
                                                    {
                                                        label: 'Remove',
                                                        key: '3',
                                                        icon: <DeleteOutlined />,
                                                        onClick: () => {
                                                            deleteTemplatebyId(item)

                                                        },
                                                    }
                                                ],
                                            }}
                                            trigger={['click']}
                                        >
                                            <a onClick={(e) => e.preventDefault()}>
                                                <Button icon={<MoreOutlined />} />
                                            </a>
                                        </Dropdown> */}
                                        </Flex>
                                    ))
                                }
                                {/* </Radio.Group> */}
                            </div>) : (
                            <Empty
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                description={
                                    <Text>No Template</Text>
                                }
                            />
                        )
                        }
                        {/* {myTemplatesV2.length > 10 && ( */}
                            <Pagination
                                current={currentPage}
                                pageSize={pageSize}
                                total={myTemplates.length}
                                onChange={(page) => pagination(page)}
                                style={{ marginTop: "10px" }}
                                align="end"
                            />
                        {/* )} */}

                    </>)}
                </Form>
                {/* Use if only exceeded 10 items */}
                {/* <Pagination align="end" defaultCurrent={1} total={50} /> */}

                {/* search filter drawer */}
                <Drawer
                    title="Create New Template"
                    onClose={closeDrawer}
                    open={openNewDrawer}
                    size="large"
                    destroyOnClose={true}
                    width={'100%'}
                    footer={[
                        <Flex justify='flex-end' align='center' gap='large'>
                            <Button onClick={closeDrawer}>
                                Cancel
                            </Button>
                            <Button
                                onClick={saveTemplate}
                                type="primary"
                            >
                                Save
                            </Button>
                        </Flex>
                    ]
                    }
                >
                    {/* <Templates /> */}
                    <Templates ref={createTemplateRef} drawerclose={closeNewDrawer} initialData={null} creationType={"new"} />
                </Drawer>
                <Drawer
                    title="Make a Copy Template"
                    onClose={closeDrawer}
                    open={openMakeCopyDrawer}
                    size="large"
                    destroyOnClose={true}
                    width={'100%'}
                    footer={[
                        <Flex justify='flex-end' align='center' gap='large'>
                            <Button onClick={closeDrawer}>
                                Cancel
                            </Button>
                            <Button
                                onClick={saveMakecopyTemplate}
                                type="primary"
                            >
                                Save
                            </Button>
                        </Flex>
                    ]
                    }
                >
                    {/* <Templates /> */}
                    {selectedMakeCopyTemplate ? <>
                        <Templates ref={makecopyTemplateRef} drawerclose={closeNewDrawer} initialData={selectedMakeCopyTemplate} creationType={"makecopy"} />
                    </> : <></>}
                </Drawer>
                <Drawer
                    title="Edit Template"
                    onClose={closeDrawer}
                    open={openEditDrawer}
                    size="large"
                    destroyOnClose={true}
                    width={'100%'}
                    footer={[
                        <Flex justify='flex-end' align='center' gap='large'>
                            <Button onClick={closeDrawer}>
                                Cancel
                            </Button>
                            <Button
                                onClick={saveEditTemplate}
                                type="primary"
                            >
                                Save
                            </Button>
                        </Flex>
                    ]
                    }
                >
                    {/* <Templates /> */}
                    {selectedEditTemplate ? <>
                        <Templates ref={editTemplateRef} drawerclose={closeNewDrawer} initialData={selectedEditTemplate} creationType={"edit"} />
                    </> : <></>}
                </Drawer>
            </div>
        </>
    )
}